import type { Popover as PopoverPrimitive } from "@base-ui/react/popover";

type PopoverOpenChangeHandler = NonNullable<PopoverPrimitive.Root.Props["onOpenChange"]>;

/**
 * Filter updates re-render popover contents and can emit a spurious focus-out.
 * Use this as `onOpenChange` for filter popovers that remount their body on state changes.
 */
export function ignorePopoverFocusOutOnChange(setOpen: (open: boolean) => void): PopoverOpenChangeHandler {
  return (open, details) => {
    if (!open && details.reason === "focus-out") {
      details.cancel();
      return;
    }
    setOpen(open);
  };
}
